import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { dealFlightSearch, formatDealDate } from "@/lib/deal-link";

/**
 * Link z kafelka ceny: gdy znamy datę lotu z feedu Aviasales, otwiera
 * wyszukiwarkę od razu na ten dzień (bilet w tej cenie); inaczej stronę trasy.
 */
export function DealLink({
  from, to, departDate, className, title, children,
}: {
  from: string; to: string; departDate?: string; className?: string; title?: string; children: ReactNode;
}) {
  const fs = dealFlightSearch(from, to, departDate);
  if (fs) {
    return (
      <Link to="/search" search={{ flightSearch: fs } as never} className={className} title={title}>
        {children}
      </Link>
    );
  }
  return (
    <Link
      to="/loty/$from/$to"
      params={{ from: from.toLowerCase(), to: to.toLowerCase() }}
      className={className}
      title={title}
    >
      {children}
    </Link>
  );
}

/** Mały napis z datą lotu pod ceną, np. „13 gru". */
export function DealDate({ departDate }: { departDate?: string }) {
  const label = formatDealDate(departDate);
  if (!label) return null;
  return <div className="text-[11px] text-muted-foreground whitespace-nowrap">wylot {label}</div>;
}
